const routes = [
  {
    path: 'konvajs',
    component: () => import(/* webpackChunkName: "konvajs" */ '@/modules/konvajs/index.vue'),
    children: [
      {
        path: '',
        name: 'konvajs',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/konvajs/demo1.vue'),
      },
      {
        path: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/konvajs/demo1.vue'),
      },
      {
        path: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/konvajs/demo2.vue'),
      },
      {
        path: 'demo3',
        component: () => import(/* webpackChunkName: "demo3" */ '@/modules/konvajs/demo3.vue'),
      },
    ],
  },
];

export default routes;